import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_2mm84w7fdj: FaireCollectionEntity = {
  token: "pbc_2mm84w7fdj",
  type: "collection",
  name: "{Open Sizing] Low Minimums on Your Favorite Bestsellers",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c5e3520cf421ad84558cb6819e558b9570e2938befcdc33c38035e7dd6df24ba.jpeg",
  itemCount: 7,
  description:
    "Open sizing + just a 6-pair minimum = easier buying, happier shelves. Shop our collection and mix sizes to fit your store’s needs. For styling tips or an exclusive look at new styles, check out our socials IG: @_lemonadeshoes or TIKTOK: @lemonadeshoes",
  brandToken: "b_mz3xxxsvnf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:39:30.362Z",
    importedBy: "entity-db-import-collections",
  },
};
